const Tag = ({ label, color, size }) => {
  if (color === 'green') {
    return (
      <div className="flex flex-row justify-center items-center bg-greenLight gap-1 px-1 py-1 rounded-sm">
        <p className="font-body leading-none text-xs font-semibold text-green">
          {label}
        </p>
      </div>
    );
  }

  if (color === 'orange') {
    return (
      <div className="flex flex-row justify-center items-center bg-orangeLight gap-1 px-1 py-0.5 rounded-sm">
        <p className="font-body leading-none text-xs font-semibold text-orange">
          {label}
        </p>
      </div>
    );
  }

  if (color === 'blue') {
    return (
      <div className="flex flex-row justify-center items-center bg-badgeLightBlue gap-1 px-1 py-0.5 rounded-sm">
        <p className="font-body leading-none text-xs font-semibold text-badgeBlue">
          {label}
        </p>
      </div>
    );
  }

  if (color === 'gray') {
    return (
      <div className="flex flex-row justify-center items-center bg-gray gap-1 px-1 py-0.5 rounded-sm">
        <p className="font-body leading-none text-xs font-semibold text-textGray">
          {label}
        </p>
      </div>
    );
  }

  if (size === 'lg') {
    return (
      <div className="flex flex-row justify-center items-center  gap-1 px-2 h-7 rounded-md my-auto">
        <p className="font-body leading-none text-sm font-medium text-[#ababab]">
          {label}
        </p>
      </div>
    );
  }
};
export default Tag;
